import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';

@Component({
  selector: 'app-feeds-company-carousel-card',
  templateUrl: './feeds-company-carousel-card.component.html',
  styleUrls: ['./feeds-company-carousel-card.component.scss']
})
export class FeedsCompanyCarouselCardComponent implements OnInit {
  @Input() companyList;

  device;

  constructor(
    private localStorage: LocalStorageService,
  ) {
    this.device = localStorage.getItem('device');
    console.log('device', this.device);
  }

  ngOnInit(): void {

    // console.log(this.companyList)
  }

}
